import React from 'react';
import PropTypes from 'prop-types';
import {Provider} from 'react-redux';
// import { Router } from 'react-router';
// import Routes from './routes';
// import {BrowserRouter as Router, Route, Switch} from "react-router";
import {BrowserRouter as Router, Route, Routes} from "react-router";
import Layout from './domains/Layout/Layout';
import history from './history';
import BenchmarkPrintPreview from './domains/ExerciseBenchmark/PrintPreview';


function Root({store}) {
  return (
    <Provider store={store}>
      <Router>
        <Routes>
          <Route path="/print-evaluation" element={<BenchmarkPrintPreview />} />
          <Route path="/*" element={<Layout />} />
        </Routes>
      </Router>
    </Provider>
  );
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  // history: PropTypes.object.isRequired,
};

export default Root;
